import { AdvancedSearchActions } from './actions'
import { AdvancedSearchGetters } from './getters'
import { AdvancedSearchMutations } from './mutations'
import { AdvancedSearchState } from './state'

export const ADVANCED_SEARCH_NAMESPACE = 'advancedSearch'

export const AdvancedSearch = {
  namespaced: true,
  state: AdvancedSearchState,
  actions: AdvancedSearchActions,
  mutations: AdvancedSearchMutations,
  getters: AdvancedSearchGetters,
}
